import { render } from "./SmallLoader.vue?vue&type=template&id=1fafdc33&scoped=true"
import script from "./SmallLoader.vue?vue&type=script&lang=js"
export * from "./SmallLoader.vue?vue&type=script&lang=js"

import "./SmallLoader.vue?vue&type=style&index=0&id=1fafdc33&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fafdc33"]])

export default __exports__